<template>
  <div>
    <b-form-select
      v-model="selected"
      :options="options"
      size="sm"
      v-on:change="updateValues"
    />
  </div>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue'
// eslint-disable-next-line import/named
import { coreApiPageMonthFilterObject } from '@/coreApi/filters/coreApiPageMonthFilter'
// eslint-disable-next-line import/no-extraneous-dependencies,no-unused-vars
const moment = require('moment')

// eslint-disable-next-line no-unused-vars
const querystring = require('querystring')

export default {
    components: {
        BFormSelect,
    },
    filters: {
    },
    props: {
    },
    data() {
        const pageMonthFilter = coreApiPageMonthFilterObject.getQueryStringFilter()
        const today = moment()
        const date = moment('2022-03-01', 'YYYY-MM-DD', true)
        let selected = today.format('YYYY-MM-01')

        if (pageMonthFilter && typeof pageMonthFilter.month !== 'undefined' && pageMonthFilter.month.length) {
            try {
                selected = moment(pageMonthFilter.month[0].slice(3), 'YYYY-MM-DD', true).format('YYYY-MM-01')
            } catch (e) {
                selected = today.format('YYYY-MM-01')
            }
        }

        const options = []
        while (true) {
            options.push(
                {
                    value: date.format('YYYY-MM-01'),
                    text: date.format('MMM YYYY'),
                    selected: (today.format('MMM yy') === date.format('MMM yy')),
                },
            )
            if (today.format('MMM yy') === date.format('MMM yy')) {
                break
            }
            date.add(1, 'months')
        }

        return {
            selected,
            options,
        }
    },
    watch: {
        $route() {
            const pageMonthFilter = coreApiPageMonthFilterObject.getQueryStringFilter()
            const today = moment()
            let selected = today.format('YYYY-MM-01')
            if (pageMonthFilter && typeof pageMonthFilter.month !== 'undefined' && pageMonthFilter.month.length) {
                try {
                    selected = moment(pageMonthFilter.month[0].slice(3), 'YYYY-MM-DD', true).format('YYYY-MM-01')
                } catch (e) {
                    selected = today.format('YYYY-MM-01')
                }
            }
            this.selected = selected
        },
    },
    methods: {
        getOpens() {
            return this.isMobile() ? 'center' : 'right'
        },
        isMobile() {
            return window.innerWidth < 768
        },
        updateValues(data) {
            if (data) {
                const filters = { month: [`mr:${this.selected}`] }
                const newPath = coreApiPageMonthFilterObject.getFilterUrl(filters)
                if (newPath !== this.$route.fullPath) {
                    this.$router.push(newPath)
                }
            }
        },
    },
}
</script>
